/**
 * 查看详情
 * 2017-12-27
 * by 于再洋
 */
"use strict";
angular.module("editseatModule", []).
controller("editseatCtrl", ["$scope", '$modalInstance', 'trsHttpService', 'item', 'trsconfirm', "$document","$timeout", "newTopicRuleService", function($scope, $modalInstance, trsHttpService, item, trsconfirm, $document,$timeout,newTopicRuleService) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            pageNo:0,
            pageSize:10,
            saveright:false,//保存提示
            saveerr:false,//错误提示
            prompt:false,//提示
            seatShow:true,//位置显示
            postype:'',//位置参数
        };
        $scope.data = {
            items: item,//接收传值
            postype:'',//位置参数
            name:'',//人员姓名/位置名称
            name8531:'',//8531用户名
            instruction:'',//人员描述/位置描述
            longitude:'',//经度
            latitude:'',//纬度
            isdisplay:true,//是否显示
        };
        $scope.promptMes ="";
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
        if($scope.data.items.info.POSTYPE==1){
            $scope.status.seatShow = true;
        }else{
            $scope.status.seatShow = false;
        }
        $scope.data.name = $scope.data.items.info.NAME;
        $scope.data.name8531 = $scope.data.items.info.NAME8531;
        $scope.data.instruction = $scope.data.items.info.INSTRUCTION;
        $scope.data.longitude = $scope.data.items.info.LONGITUDE;
        $scope.data.latitude = $scope.data.items.info.LATITUDE;
    }
    /**
     * [seatsave description] 保存
     * @return {[type]} [description]
     */
        $scope.seatsave = function() {       
        if($scope.status.seatShow == true){
            $scope.data.postype = 1;
        }else{
            $scope.data.postype = 2;
        }
        if($scope.data.postype == 1){
            if($scope.data.name == ''){
                $scope.status.prompt = true;
                $scope.promptMes = "人员姓名不能为空！";
                $timeout(function(){
                    $scope.status.prompt = false;
                },2000);
                return;
            }else if($scope.data.name8531 == ''){
                $scope.status.prompt = true;
                $scope.promptMes = "8531用户名不能为空！";
                $timeout(function(){
                    $scope.status.prompt = false;
                },2000);
                return;
            }else if($scope.data.instruction == ''){
                $scope.status.prompt = true;
                $scope.promptMes = "人员描述不能为空！";
                $timeout(function(){
                    $scope.status.prompt = false;
                },2000);
                return;
            }else{
                saveParams();
            }
        } else if ($scope.data.postype == 2){
            if($scope.data.name == ''){
                $scope.status.prompt = true;
                $scope.promptMes = "位置名称不能为空！";
                $timeout(function(){
                    $scope.status.prompt = false;
                },2000);
                return;
            }else if($scope.data.longitude == '' || $scope.data.latitude == ''){
                $scope.status.prompt = true;
                $scope.promptMes = "位置坐标不能为空！";
                $timeout(function(){
                    $scope.status.prompt = false;
                },2000);
                return;
            }else{
                saveParams();
            }
        }
        
    };
    /**
     * [saveParams description] 保存服务
     * @return {[type]} [description]
     */
    function saveParams(){
        $scope.params = {
            "typeid": 'screen',
            "serviceid": 'mapPostionMgr',
            "modelid": 'save',
            "postype": $scope.data.postype,
            "name": $scope.data.name,
            "name8531": $scope.data.name8531,
            "instruction":$scope.data.instruction,
            "longitude":$scope.data.longitude,
            "latitude":$scope.data.latitude,
            "mapcontrol_id": $scope.data.items.info.MAPCONTROLID,
            "id":$scope.data.items.info.ID,
            "isdisplay":$scope.data.isdisplay,
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, "post").then(function(data) {
            $scope.status.saveright = true;
            $scope.promptMes = "添加成功！";
            $timeout(function(){
                $scope.status.saveright = false;
                $modalInstance.close(true);
            },2000);
        });
    }
    /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.cancel = function() {
        $modalInstance.dismiss();

    };
    /**
     * [cancel description] 删除绑定信息
     * @return {[type]} [description]
     */
    $scope.deletemes = function() {
        $scope.data.name = '';//人员姓名/位置名称
        $scope.data.name8531 = '';//8531用户名
        $scope.data.instruction = '';//人员描述/位置描述
        $scope.data.longitude = '';//经度
        $scope.data.latitude = '';//纬度
    };
}]);